<template>
  <md-card-content>
    <md-field>
      <label>{{$t("games.throwPapers.duration")}}</label>
      <md-input v-model="durationThrowPapers"></md-input>
    </md-field>
    <md-field>
      <label>{{$t("games.throwPapers.goalThreshold")}}</label>
      <md-input v-model="goalThreshold"></md-input>
    </md-field>
    <md-button :disabled="durationThrowPapers == 0 || goalThreshold == 0" class="md-block md-success" @click="requestThrowPapers(teamId, Number(durationThrowPapers), Number(goalThreshold))">{{$t("games.throwPapers.send")}}</md-button>
  </md-card-content>
</template>
<script>
export default {
  props: {
    teamId: Number,
    gameId: Number
  },
  data() {
    return {
      durationThrowPapers: 0,
      goalThreshold: 50
    }
  },
  methods: {
    async requestThrowPapers(teamId, duration, goalThreshold) {
      const params = {
        gameId: this.gameId,
        teamId,
        duration,
        goalThreshold
      }
      const request = await this.$store.dispatch('requestThrowPapers', params)
      if (request != undefined) {
        this.$notify({
          message: this.$t(`notifications.game.throwPapers`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      } 
    }
  }
}
</script>

<style>
  
</style>